import { render, staticRenderFns } from "./GettingStartedModal.vue?vue&type=template&id=4f81d562"
import script from "./GettingStartedModal.vue?vue&type=script&lang=ts"
export * from "./GettingStartedModal.vue?vue&type=script&lang=ts"
import style0 from "./GettingStartedModal.vue?vue&type=style&index=0&id=4f81d562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports